module.exports = __webpack_public_path__ + "static/media/browser-image-compression.27d504fd.mjs";